export default __webpack_public_path__ + "static/media/1984.f13909d1.png";